module.exports = __webpack_public_path__ + "img/arg.3c483827.svg";